import React from "react";

const EmailInstructions = () => {
  return (
    <p>
      We have a sent you a verification email with link to click. If you can't
      find the email, please check your Junk/Spam folder.
    </p>
  );
};

export default EmailInstructions;



// WEBPACK FOOTER //
// ./src/components/email_instructions/EmailInstructions.jsx